import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToAnchor from './components/ScrollToAnchor';
import Home from './pages/Home';
import Programacao from './pages/Programacao';
import Galeria from './pages/Galeria';
import Nowhere from './pages/Nowhere';

export default function RoutesApp() {
    return (
        <>
            <ScrollToAnchor />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/programacao" element={<Programacao />} />
                <Route path="/galeria" element={<Galeria />} />
                <Route path="*" element={<Nowhere />} />
            </Routes>
        </>
    );
}
